import moment from 'moment';
import { useTranslation } from 'react-i18next';

const JobDate = ({ label, date }) => {
  const { t } = useTranslation();

  const mdate = moment(date);
  let formatted_date = '--';

  if (mdate.isValid()) {
    formatted_date = mdate.format('DD/MM/YYYY HH:mm');
  }

  return (
    <div className="lh-sm  mb-2">
      <small>{t(label)}</small> <br />
      <b>{formatted_date}</b>
    </div>
  );
};

export default JobDate;
